var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    viewBox: "0 0 192.756 192.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h192.756v192.756H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.979 135.844c21.796 0 39.467-17.67 39.467-39.466s-17.67-39.466-39.467-39.466-39.467 17.67-39.467 39.466 17.67 39.466 39.467 39.466z",
    fill: "#a70b52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.589 110.267h-8.173v-30.89h-3.031v33.938h3.031v-.02h8.173z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.989 97.642H62.637v-3.031H85.97c.031.586.046 1.173.046 1.767 0 18.247-14.792 33.038-33.038 33.038S19.94 114.625 19.94 96.378 34.732 63.34 52.979 63.34c.481 0 .961.01 1.438.031l-.004 3.008a31.023 31.023 0 0 0-1.434-.033c-16.586 0-30.033 13.446-30.033 30.032 0 16.587 13.446 30.032 30.033 30.032 16.134 0 29.296-12.722 30.002-28.683l.008-.085z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.655 88.521a4.642 4.642 0 1 0 0-9.285 4.642 4.642 0 0 0 0 9.285z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#808183",
    d: "M112.043 115.75h28.201v-8.517h-17.847V76.735h-10.354zM174.317 79.482c-3.233-2.505-7.396-3.775-12.364-3.775-5.899 0-10.828 1.812-14.255 5.236-3.577 3.579-5.471 8.851-5.471 15.246 0 6.832 2.002 12.597 5.637 16.229 2.854 2.853 6.656 4.358 11.007 4.358 9.551 0 11.748-5.725 11.748-5.725V115.748h8.625V93.714h-17.169v6.895H169.977s.076 8.681-8.08 8.681c-2.072 0-3.918-.752-5.338-2.172-2.213-2.211-3.383-5.937-3.383-10.767 0-8 3.18-12.776 8.504-12.776 3.326 0 5.826 2.042 6.467 5.137h10.984c-.569-4.497-1.803-6.841-4.814-9.23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgLogo);
export default __webpack_public_path__ + "static/media/lg_logo.b7a07da36287d46d6fdac2ea9ab51a45.svg";
export { ForwardRef as ReactComponent };